import React from 'react';

// Phones get a tighter rhythm: 60% of the tablet (lg) spacing unless `sm` is given.
const phoneSpacing = (lg) => {
  const value = Number(lg);
  return Number.isFinite(value) ? Math.round(value * 0.6) : '_';
};

export default function Spacing({ xl = '_', lg = '_', md = '_', sm }) {
  const smValue = sm ?? phoneSpacing(lg);
  return (
    <div
      className={`cs_height_xl_${xl} cs_height_lg_${lg} cs_height_${md} cs_height_sm_${smValue}`}
    ></div>
  );
}
